import { Sidebar as L2RSidebar, styled } from "@l2r-front/l2r-ui"

export const Sidebar = styled(L2RSidebar)(({ theme }) => ({
    "& .MuiDrawer-paper": {
        padding: theme.spacing(8, 0, 0, 0),
    },
}))